module.exports = __webpack_public_path__ + "img/1321808251.b79f0120.jpg";